import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class DataService {

private _user$ = new BehaviorSubject<User>(<User>(null)); // NOSONAR

  get user$(): Observable<User> { return this._user$.asObservable(); }

  get user(): User { return this._user$.getValue(); }

  setData(filters) {
    this._user$.next(filters);
  }

}

export interface User {
  gridFilters: any 
};
